export const sanitizeString = (text: string): string => {
    const allowedCharacters = /[^a-zA-Z0-9\-_/. *&%$#@!]/g; // Match characters to be removed
    return text.replace(allowedCharacters, '');
};